import { render } from "./RestaurantPage.vue?vue&type=template&id=6d21ea33&ts=true"
import script from "./RestaurantPage.vue?vue&type=script&lang=ts"
export * from "./RestaurantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__